import type { ReactNode } from "react";
import { AppHeader } from "./AppHeader";

interface ScreenShellProps {
  readonly children: ReactNode;
  readonly className?: string;
  readonly backLabel?: string;
  readonly onBack?: () => void;
  /** Primary action(s) docked to the bottom of the screen. */
  readonly footer?: ReactNode;
}

export function ScreenShell({
  children,
  className = "",
  backLabel,
  onBack,
  footer
}: ScreenShellProps) {
  return (
    <div className={`app-shell ${className}`.trim()}>
      <AppHeader
        {...(backLabel === undefined ? {} : { backLabel })}
        {...(onBack === undefined ? {} : { onBack })}
      />
      <main className={`screen-content${footer === undefined ? "" : " screen-content--with-footer"}`}>
        {footer === undefined ? children : <div className="screen-content__body">{children}</div>}
      </main>
      {footer === undefined ? null : (
        <footer className="screen-footer">
          <div className="screen-footer__inner">{footer}</div>
        </footer>
      )}
    </div>
  );
}
